export const USER_API = {
  createUser: `users`,
  getUser: (email: string) => `api/users/byEmail/${email}`,
  getUsers: `api/users`,
};

type UserLocationData = {
  country: string;
  countryName: string;
  dir: string;
  id: number;
  lat: number;
  lon: number;
  neighborhood: string;
  neighborhoodName: string;
  postalCode: string;
  provider: null;
  referenceId: string;
  state: string;
  stateName: string;
  streetnumber: string;
  userId: string;
};

export type User = {
  additionalEmail: string;
  email: string;
  id: number;
  lastName: string;
  locationData: UserLocationData[];
  name: string;
  phone: string;
  rfc: string;
};

export type CreateUser = {
  user: {
    name: string;
    fatherLastName: string;
    motherLastName: string;
    rfc: string;
    curp: string;
    phone: string;
    fiscalDoc: string;
    email: string;
    additionalEmail: string;
    password: string;
  };
  deliveryAddress: {
    countryId: number;
    country: string;
    zipCode: number;
    stateId: number;
    state: string;
    cityId: number;
    city: string;
    neighborhoodId: number;
    neighborhood: string;
    street: string;
    externalNumber: number;
    internalNumber?: number;
    lat: number;
    lon: number;
  };
  fiscalAddress: {
    countryId: number;
    country: string;
    zipCode: number;
    stateId: number;
    state: string;
    cityId: number;
    city: string;
    neighborhoodId: number;
    neighborhood: string;
    street: string;
    externalNumber: number;
    internalNumber?: number;
  };
};
